import ListWalletRequests from "../../../../components/@transactions/wallet/ListWalletRequests";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function WalletRequestsPage() {

    return (
        <ListWalletRequests
            routeType={routeTypes.admin}
        />
    )
}       